const state = {
  isOpen: false,
};

const getters = {
  isNavOpen: (state) => state.isOpen,
};

const actions = {
  toggleNav({ commit }) {
    commit("setNavBar", null);
  },
};

const mutations = {
  setNavBar: (state) => (state.isOpen = !state.isOpen),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
